// @ts-ignore
import { SwitchActiveColor } from '@/shared/components/button-switch.component.vue';

export default class Constants {
  public static SpecialAnnouncementId = '6b3564af-359e-406d-9cc5-91e9f0404fe5';
  public static notificationMessageTimeToAppear = 3000;
  public static downloadCsvLimit = 1500;
  public static timeoutMethodsRemainingTimeDev = 60000;
  public static timeoutMethodsRemainingTimePro = 15000;
  public static searchEmitTime = 500;
  public static requestTimeoutTime = 800;
  public static defaultTimeoutTime = 300;
  public static middleTimeoutTime = 500;
  public static switchConference = {
    id: 1,
    text: 'Conferencias',
    requestName: 'conference',
  };
  public static switchCourse = {
    id: 2,
    text: 'Cursos',
    requestName: 'course',
    activeColor: SwitchActiveColor.Primary,
  };
  public static switchEvent = {
    id: 3,
    text: 'Eventos',
    requestName: 'event',
    activeColor: SwitchActiveColor.Primary,
  };
  public static switchPast = { id: 1, text: 'Pasadas' };
  public static switchFuture = {
    id: 2,
    text: 'Futuras',
    activeColor: SwitchActiveColor.Primary,
  };
  public static switchGenerals = {
    id: 1,
    text: 'Clientes',
    requestName: 'general'
  };
  public static switchConvocations = {
    id: 2,
    text: 'Convocatorias',
    requestName: 'convocatorias',
  };
  public static switchPurchases = {
    id: 3,
    text: 'Compras',
    requestName: 'compras'
  };
  public static switchBudgets = {
    id: 4,
    text: 'Altas',
    requestName: 'presupuestos'
  };
  public static switchFiscalDataExtension = {
    id: 5,
    text: 'Datos fiscales',
    requestName: 'facturación'
  };
  public static switchBills = {
    id: 6,
    text: 'Facturación',
    requestName: 'facturas'
  };
  public static switchPaymentMethods = {
    id: 7,
    text: 'Formas de pago',
    requestName: 'pagoAplazado'
  };
  public static internalServerErrorMessage =
    'Ups, parece que estamos teniendo algún problema...';
  public static timeToBeginBudgetPayments = 15;
  public static inscriptionCompleteUrl =
    'https://eventoslevelup.com/inscripcion-completada/';
  public static budgetConditions =
    'https://www.levelupdesarrollo.com/politica-de-cancelacion/';
  public static delegationNotConfirmed = 'Por definir';
  public static openDate = 'Fecha abierta';
}
